/**
 * Map tabs
 */
// get globally-available features
const tabs = window.aquaminTabs;
const toggle = window.aquaminToggle;

// create essentially isolated, nested tabs via carefully crafted selectors
document.querySelectorAll('.resort-map-acc')?.forEach((el) => {
	const { id } = el;
	el.querySelectorAll('[data-id]')?.forEach((acc, i) => {
		tabs(`${id}-${i}`, {
			selectors: {
				wrap: `#${id} .${acc.dataset.id}`,
				toggles: `#${id} .${acc.dataset.id}-toggle`,
				content: `#${id} .${acc.dataset.id}-content`,
			},
		});
	});
});

// set up mobile menu toggle
toggle('resort-map-menu', {
	wrap: '.resort-map__sidebar',
	triggers: '.resort-map__sidebar-toggle',
	menu: '.resort-map__sidebar-menu',
});
